import React, { Component } from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";

import { KeyNavigation } from "../KeyNavigation/KeyNavigation.component";

import "./KeyHistory.component.scss";

import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { ActionCreator } from "../../../../actions/actions";
import { connect } from "react-redux";
import { keyRequestsStoreSelectors } from "../../store/store";
import { KeyActionCreators } from "../../actions/actionCreators";
import Paginator from "../../../../utils/Paginator/Paginator.component";
import { checkAuthorization } from "./../../../../utils/Authorization/authorization";
import Moment from "moment";

export interface KeyHistoryProps extends RouteComponentProps {
    getKeyRequests: ActionCreator;
    keyRequests: {
        results: any[];
        count: number;
    };
    keyRequestLoading: boolean;
}

export interface KeyHistoryState {
    currentPage: 1;
}

class KeyHistory extends Component<KeyHistoryProps, KeyHistoryState> {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1
        };
    }

    componentDidMount() {
        this.props.getKeyRequests({
            page: this.state.currentPage,
            top: 24
        });
    }

    pageChange = newPage => {
        this.props.getKeyRequests({
            page: newPage,
            top: 24
        });

        this.setState({
            currentPage: newPage
        });
    };

    renderKeyRequests() {
       if (this.props.keyRequests.results.length === 0) {
            return (
                <div className="key-list-no-requests">
                    No history to display.
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="key-activities-container">
                        <table>
                            <thead>
                                <tr>
                                    <td colSpan={2}>User</td>
                                    <td>Usage</td>
                                    <td>Notes</td>
                                    <td className="activity-date">Date</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.keyRequests.results.map(
                                    (request, key) => (
                                        <tr key={key}>
                                            <td className="activity-user-image">
                                                {request.user && (
                                                    <React.Fragment>
                                                        {(request.user
                                                            .profile_picture_base64 ==
                                                            "" ||
                                                            request.user
                                                                .profile_picture_base64 ==
                                                                undefined) && (
                                                            <div className="user-icon">
                                                                <i className="icon-user-light"></i>
                                                            </div>
                                                        )}
                                                        {request.user
                                                            .profile_picture_base64 !==
                                                            "" &&
                                                            request.user
                                                                .profile_picture_base64 !==
                                                                undefined && (
                                                                <div
                                                                    style={{
                                                                        backgroundImage: `url('data:image;base64,${request.user.profile_picture_base64}')`
                                                                    }}
                                                                ></div>
                                                            )}
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td className="activity-user">
                                                {request.user && (
                                                    <React.Fragment>
                                                        <div>
                                                            <p>
                                                                {`${request.user.first_name} ${request.user.last_name}`}
                                                            </p>
                                                            <span>
                                                                {request.user
                                                                    .is_superuser
                                                                    ? "Administrator"
                                                                    : ""}
                                                            </span>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </td>
                                            <td className="activity-user">
                                                <div>
                                                    <p>{request.usage}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <p>{request.notes && request.notes !== "undefined" ? request.notes : ""}</p>
                                                </div>
                                            </td>
                                            <td className="activity-date">
                                                {Moment(
                                                    new Date(request.timestamp)
                                                ).format(
                                                    "DD MMM YYYY @ HH:mm:ss"
                                                )}
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="col-12 paginator-col">
                        <Paginator
                            currentPage={this.state.currentPage}
                            totalPages={
                                Math.floor(this.props.keyRequests.count / 24) +
                                1
                            }
                            onPageChange={this.pageChange}
                        />
                    </div>
                </React.Fragment>
            );
        }
    }

    render() {
        return (
            <div id="KeyRequestList" className="content">
                <KeyNavigation></KeyNavigation>
                <div className="container">
                    <div>
                        {this.props.keyRequestLoading ? (
                            <div className="key-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="key-list-card">
                                <div className="keys">
                                    <div className="row">
                                        {this.renderKeyRequests()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    keyRequests: keyRequestsStoreSelectors.keyRequests(state),
    keyRequestLoading: keyRequestsStoreSelectors.keyRequestLoading(state)
});

const mapDispatchToProps = {
    getKeyRequests: KeyActionCreators.getKeyRequests
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(KeyHistory));
